import { render } from "./BucketList.vue?vue&type=template&id=f08262c8"
import script from "./BucketList.vue?vue&type=script&lang=js"
export * from "./BucketList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rswenson/code/data_lake/wld-api/spa_src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__